/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const rebuildCollectionClosureV1ResultSchema = z.object({
  collectionCount: z.number(),
  selfRowCount: z.number(),
  totalRows: z.number(),
  consistent: z.boolean(),
});

export type IRebuildCollectionClosureV1Result = z.infer<
  typeof rebuildCollectionClosureV1ResultSchema
>;

export const rebuildCollectionClosureV1ResponseSchema = createApiResponseSchema(
  rebuildCollectionClosureV1ResultSchema,
) as z.ZodSchema<IAPI<IRebuildCollectionClosureV1Result>>;

export type IRebuildCollectionClosureV1Response = IAPI<IRebuildCollectionClosureV1Result>;
